import { render, staticRenderFns } from "./TheLeaseIDTsList.vue?vue&type=template&id=741520cb&"
import script from "./TheLeaseIDTsList.vue?vue&type=script&lang=js&"
export * from "./TheLeaseIDTsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports